import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { profileApi } from './profile.api'
import { useAppDispatch, showLoader, hideLoader, showSnackbar } from '@/store'
import { getResponseMessage } from '@/utils'
import type { CreateProviderPayload } from '@/services/users'

export const profileKeys = {
  current: () => ['profile', 'current'] as const,
}

export const useProfile = (enabled = true) =>
  useQuery({
    queryKey: profileKeys.current(),
    queryFn: () => profileApi.getCurrent(),
    enabled,
  })

// PUT /api/master/provider/profile
export const useUpdateMyProfile = () => {
  const queryClient = useQueryClient()
  const dispatch = useAppDispatch()

  return useMutation({
    mutationFn: (payload: CreateProviderPayload) => profileApi.updateCurrent(payload),
    onMutate: () => dispatch(showLoader()),
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: profileKeys.current() })
      dispatch(hideLoader())
      dispatch(
        showSnackbar({
          severity: 'success',
          message: getResponseMessage(response, 'Profile updated successfully!'),
        }),
      )
    },
    onError: (error: unknown) => {
      dispatch(hideLoader())
      dispatch(
        showSnackbar({
          severity: 'error',
          message: getResponseMessage(error, 'Failed to update profile'),
        }),
      )
    },
  })
}
